import { render, staticRenderFns } from "./CsFormLabel.vue?vue&type=template&id=31d0c85e&"
import script from "./CsFormLabel.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsFormLabel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports